import { KiaPage_Pagebuilder } from '@/graphql/generated/graphql';
import { ElementType, useEffect } from 'react';
import CarCarousel from './blocks/CarCarousel';
import CarCarouselGrid from './blocks/CarCarouselGrid';
import ChecklistBlock from './blocks/ChecklistBlock';
import ColoredHero from './blocks/colored-hero';
import Columns from './blocks/columns';
import ContentBlocks from './blocks/ContentBlocks';
import FaqsBlock from './blocks/FaqsBlock';
import GalleryBlock from './blocks/GalleryBlock';
import HeroBlock from './blocks/HeroBlock';
import IframeBlock from './blocks/IframeBlock';
import ImageBlock from './blocks/ImageBlock';
import KiaModuleBlock from './blocks/kia-module';
import LaddboxForm from './blocks/LaddboxForm';
import LogotypesBlock from './blocks/LogotypesBlock';
import NavBlock from './blocks/NavBlock';
import StoryBlock from './blocks/story/StoryBlock';
import TableBlock from './blocks/TableBlock';
import TabsBlock from './blocks/TabsBlock';
import TextAndMedia from './blocks/TextAndMedia';
import Texteditor from './blocks/Texteditor';
import WowForm from './blocks/way-out-west/form';

type ConcreteBlock = NonNullable<
  NonNullable<KiaPage_Pagebuilder['blocks']>[number]
>;

type BlockTypeName = ConcreteBlock['__typename'];

const BLOCK_COMPONENTS: Partial<Record<BlockTypeName, ElementType>> = {
  KiaPage_Pagebuilder_Blocks_Hero: HeroBlock,
  KiaPage_Pagebuilder_Blocks_ColumnsBlock: Columns,
  KiaPage_Pagebuilder_Blocks_Texteditor: Texteditor,
  KiaPage_Pagebuilder_Blocks_Image: ImageBlock,
  KiaPage_Pagebuilder_Blocks_Checklist: ChecklistBlock,
  KiaPage_Pagebuilder_Blocks_ContentList: ContentBlocks,
  KiaPage_Pagebuilder_Blocks_Gallery: GalleryBlock,
  KiaPage_Pagebuilder_Blocks_Nav: NavBlock,
  KiaPage_Pagebuilder_Blocks_Table: TableBlock,
  KiaPage_Pagebuilder_Blocks_Tabs: TabsBlock,
  KiaPage_Pagebuilder_Blocks_Faqs: FaqsBlock,
  KiaPage_Pagebuilder_Blocks_CarCarousel: CarCarousel,
  KiaPage_Pagebuilder_Blocks_CarCarouselGrid: CarCarouselGrid,
  KiaPage_Pagebuilder_Blocks_LaddboxBlock: LaddboxForm,
  KiaPage_Pagebuilder_Blocks_LayoutKiaModules: KiaModuleBlock,
  KiaPage_Pagebuilder_Blocks_Iframe: IframeBlock,
  KiaPage_Pagebuilder_Blocks_Logotypes: LogotypesBlock,
  KiaPage_Pagebuilder_Blocks_WowForm: WowForm,
  KiaPage_Pagebuilder_Blocks_ColoredHero: ColoredHero,
  KiaPage_Pagebuilder_Blocks_Story: StoryBlock,
  KiaPage_Pagebuilder_Blocks_TextMedia: TextAndMedia,
};

export default function PageBuilder({ blocks }: KiaPage_Pagebuilder) {
  useEffect(() => {
    if (!blocks || !window.location.hash) return;
    const id = decodeURIComponent(window.location.hash.slice(1));
    const raf = requestAnimationFrame(() => {
      document.getElementById(id)?.scrollIntoView();
    });
    return () => cancelAnimationFrame(raf);
  }, [blocks]);

  if (!blocks) return null;

  return (
    <>
      {blocks.map((block, index) => {
        if (!block) return null;
        const Component = BLOCK_COMPONENTS[block.__typename];
        if (Component) {
          return <Component key={index} {...block} index={index} />;
        }
        if (process.env.NODE_ENV === 'development') {
          console.warn(`Unknown block type: ${block.__typename}`);
        }
        return null;
      })}
    </>
  );
}
